// A layout is a set of named regions. A region has a kind, which says how
// several contributions share it. The geometry is in layout.css, keyed by
// the layout's name and the region's name.
export type RegionKind = 'single' | 'stack' | 'row' | 'tabs';

export interface LayoutDefinition {
  regions: Record<string, RegionKind>;
}

export const layouts: Record<string, LayoutDefinition> = {
  // Home: one column of sections, the last 30 days: the summary and three
  // cards of each stage.
  home: {
    regions: { sections: 'stack' },
  },
  // Game stats: one column, the game bar and the selected game's sections.
  game: {
    regions: { sections: 'stack' },
  },
  // Library: a toolbar across the top, the games beneath.
  library: {
    regions: { toolbar: 'row', filters: 'row', games: 'single' },
  },
  // Settings: one column of sections, each a plugin's own.
  settings: {
    regions: { sections: 'stack' },
  },
  // Openings: one column of sections, wider than settings for its table of bars.
  openings: {
    regions: { sections: 'stack' },
  },
  // Middlegame: the same column as openings, under its own name.
  middlegame: {
    regions: { sections: 'stack' },
  },
  // Ending: the same column again.
  ending: {
    regions: { sections: 'stack' },
  },
  // Blunders and misses: the same column again (placeholders for now).
  blunders: {
    regions: { sections: 'stack' },
  },
  misses: {
    regions: { sections: 'stack' },
  },
  // Review, as in v1: the game bar across the top with the way back before
  // it, then three working columns: the scoresheet, the board, and the
  // shortlist over a tabbed column.
  review: {
    // sideTop sits above the tabbed column and keeps its content height: the
    // engine's shortlist lives there, visible whichever tab is open.
    regions: { header: 'row', left: 'stack', center: 'stack', sideTop: 'single', right: 'tabs' },
  },
};
